export const CALL_FOCUS_OPTIONS = {
  "Appointment Reminder": false,
  Medical: false,
  Medication: false,
  Other: false,
  SDoH: false,
  SUD: false,
  "Suicide Ideations/Crisis": false,
  "Symptom Management": false,
};
